export default {"src":"/_next/static/media/4.e4a2d794.svg","height":15,"width":21,"blurWidth":0,"blurHeight":0};